import { Capacitor } from '@capacitor/core';
import { Browser } from '@capacitor/browser';

/**
 * Safely opens an external URL (such as court PDFs, VC Teams meetings, or mhc.tn.gov.in)
 * in the system's native browser / PDF viewer app on Android, or a new tab on web.
 */
export async function openExternalUrl(url: string): Promise<void> {
  if (!url) return;

  if (Capacitor.isNativePlatform()) {
    try {
      await Browser.open({ url, windowName: '_system' });
      return;
    } catch (err) {
      console.warn('[openExternalUrl] Capacitor Browser.open failed, falling back to window.open:', err);
    }
  }

  window.open(url, '_blank', 'noopener,noreferrer');
}
